'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _gild = require('gild');

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _jssNested = require('jss-nested');

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jss = require('jss');

var _jss2 = _interopRequireDefault(_jss);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _qaSelector = require('@influitive/qa-selector');

var _qaSelector2 = _interopRequireDefault(_qaSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

_jss2.default.use((0, _jssNested2.default)());

var ToggleSwitch = (0, _recompose.withHandlers)({
  onClick: function onClick(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value,
        _ref$enabled = _ref.enabled,
        enabled = _ref$enabled === undefined ? true : _ref$enabled;
    return function (e) {
      e.preventDefault();
      if (enabled) onChange(!value);
    };
  },
  onToggle: function onToggle(_ref2) {
    var onChange = _ref2.onChange;
    return function (e) {
      onChange(e.target.checked);
    };
  }
})(function (_ref3) {
  var _classNames2, _classNames3;

  var value = _ref3.value,
      _ref3$trueLabel = _ref3.trueLabel,
      trueLabel = _ref3$trueLabel === undefined ? 'On' : _ref3$trueLabel,
      _ref3$falseLabel = _ref3.falseLabel,
      falseLabel = _ref3$falseLabel === undefined ? 'Off' : _ref3$falseLabel,
      onClick = _ref3.onClick,
      onToggle = _ref3.onToggle,
      className = _ref3.className,
      _ref3$enabled = _ref3.enabled,
      enabled = _ref3$enabled === undefined ? true : _ref3$enabled,
      _ref3$inputProps = _ref3.inputProps,
      inputProps = _ref3$inputProps === undefined ? {} : _ref3$inputProps,
      _ref3$changeColor = _ref3.changeColor,
      changeColor = _ref3$changeColor === undefined ? true : _ref3$changeColor,
      theme = _ref3.theme,
      rest = _objectWithoutProperties(_ref3, ['value', 'trueLabel', 'falseLabel', 'onClick', 'onToggle', 'className', 'enabled', 'inputProps', 'changeColor', 'theme']);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_styles2.default.container, _defineProperty({}, _styles2.default.disabled, !enabled), className) },
    _react2.default.createElement(
      'div',
      { 'data-qa': (0, _qaSelector2.default)('toggle-control', rest), className: (0, _classnames2.default)(_styles2.default.row), onClick: onClick },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_styles2.default.falseOption, theme['option'], (_classNames2 = {}, _defineProperty(_classNames2, _styles2.default.active, !value), _defineProperty(_classNames2, _styles2.default.off, !value && changeColor), _classNames2)) },
        falseLabel
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_styles2.default.trueOption, theme['option'], (_classNames3 = {}, _defineProperty(_classNames3, _styles2.default.active, value), _defineProperty(_classNames3, _styles2.default.off, !value && changeColor), _classNames3)) },
        trueLabel
      )
    ),
    _react2.default.createElement(
      'label',
      { className: _styles2.default.srOnly },
      trueLabel,
      _react2.default.createElement('input', _extends({
        'data-qa': (0, _qaSelector2.default)('toggle-value', rest),
        type: 'checkbox',
        className: _styles2.default.input,
        checked: value,
        onChange: onToggle,
        disabled: !enabled
      }, inputProps))
    )
  );
});

ToggleSwitch.propTypes = {
  value: _propTypes2.default.bool.isRequired,
  changeColor: _propTypes2.default.bool,
  trueLabel: _propTypes2.default.string,
  falseLabel: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  enabled: _propTypes2.default.bool,
  inputProps: _propTypes2.default.object,
  theme: _propTypes2.default.object
};

exports.default = (0, _gild.connectTheme)(_theme2.default)(ToggleSwitch);